import { PayloadAction } from '@reduxjs/toolkit';
import { Player, PlayersState } from '../state';

export const fetchGraduationPlayers = (state: PlayersState, action: PayloadAction<{ [year: number]: Player[] }>) => {
    state.graduation = action.payload;
}

export const changeSelectedYear = (state: PlayersState, action: PayloadAction<number>) => {
    state.year = action.payload;
}
